<template>
	<div class="customer-label">
		<van-popup v-model="show" position="bottom" round :style="{ height: '70%' }">
			<div class="label-container">
			<!-- 标题栏 -->
			<div class="header">
				<span class="title">{{ isEditMode ? '编辑标签' : '选择标签' }}</span>
				<van-icon name="cross" @click="$hide" />
			</div>

			<!-- 标签列表 -->
			<div class="label-list">
				<van-loading v-if="loading" type="spinner" style="text-align: center; padding: var(--base-px-40) 0;">
					加载中...
				</van-loading>
				<van-empty v-else-if="tagList.length === 0" description="暂无标签" />
				<van-checkbox-group v-else v-model="selectedTags">
					<div class="label-item" v-for="item in tagList" :key="item.id">
						<van-checkbox 
							:name="item.id"
							shape="square"
						>
							<div class="label-info">
								<van-tag type="primary" size="medium">{{ item.name }}</van-tag>
								<span class="label-count">{{ item.user_count || 0 }}人使用</span>
							</div>
						</van-checkbox>
					</div>
				</van-checkbox-group>
			</div>

			<!-- 底部按钮 -->
			<div class="footer">
				<div class="selected-info">
					<template v-if="isEditMode">
						<span>正在为 <span class="user-name">{{ currentUser.nickname || currentUser.name }}</span> 编辑标签</span>
						<span style="margin-left: 12px;">已选择标签：<span class="count">{{ selectedTags.length }}</span> 个</span>
					</template>
					<template v-else>
						<span>已选择用户：<span class="count">{{ selectedUsers.length }}</span> 人</span>
						<span style="margin-left: 12px;">已选择标签：<span class="count">{{ selectedTags.length }}</span> 个</span>
					</template>
				</div>
				<div class="footer-buttons">
					<van-button plain @click="$hide" :disabled="submitting">取消</van-button>
					<van-button type="primary" @click="handleConfirm" :loading="submitting">确定</van-button>
				</div>
			</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { getTagListAll, setUserBindLabel } from "@/api/channelCode";

export default {
	data() {
		return {
			show: false,
			tagList: [],
			selectedTags: [],
			selectedUsers: [], // 已选择的用户数组或用户对象
			isEditMode: false, // 是否为编辑模式（单个用户）
			currentUser: null, // 当前编辑的用户对象
			loading: false,
			submitting: false // 提交中状态
		}
	},
	created() {

	},
	watch: {},
	methods: {
		/**
		 * 打开弹窗
		 * @param {Array|Object} data - 用户ID数组（批量模式）或用户对象（编辑模式）
		 */
		$show(data) {
			this.show = true;
			
			// 判断是批量模式还是编辑模式
			if (Array.isArray(data)) {
				// 批量模式：传入用户ID数组
				this.isEditMode = false;
				this.selectedUsers = [...data];
				this.selectedTags = [];
				this.currentUser = null;
			} else if (data && typeof data === 'object') {
				// 编辑模式：传入用户对象
				this.isEditMode = true;
				this.currentUser = data;
				this.selectedUsers = [data.id];
				// 回显用户已有的标签
				this.selectedTags = data.tags ? data.tags.map(tag => tag.id) : [];
			} else {
				// 默认批量模式
				this.isEditMode = false;
				this.selectedUsers = [];
				this.selectedTags = [];
				this.currentUser = null;
			}
			
			// 加载标签列表
			this.getTagList();
		},
		$hide() {
			this.show = false;
		},
		// 获取标签列表（一次性加载全部）
		getTagList() {
			let _this = this;
			this.loading = true;
			getTagListAll().then(res => {
				console.log('标签列表:', res);
				if (res.code === 1) {
					_this.tagList = res.data || [];
				} else {
					_this.$toast.fail(res.msg || '获取标签列表失败');
				}
			}).catch(err => {
				console.error('获取标签列表失败:', err);
				_this.$toast.fail('获取标签列表失败');
			}).finally(() => {
				_this.loading = false;
			});
		},
		// 确认选择并绑定
		handleConfirm() {
			// 验证是否有用户
			if (this.selectedUsers.length === 0) {
				this.$toast.fail('未选择用户');
				return;
			}

			// 显示确认对话框
			let message = '';
			if (this.isEditMode) {
				const userName = this.currentUser.nickname || this.currentUser.name || '该用户';
				message = `将为 ${userName} 绑定 ${this.selectedTags.length} 个标签`;
			} else {
				message = `将为 ${this.selectedUsers.length} 个用户绑定 ${this.selectedTags.length} 个标签`;
			}
			
			this.$dialog.confirm({
				title: this.isEditMode ? '确认编辑' : '确认绑定',
				message: message,
			}).then(() => {
				this.submitBindLabel();
			}).catch(() => {
				// 取消操作
			});
		},
		// 提交绑定标签
		submitBindLabel() {
			this.submitting = true;
			
			// 构建后端需要的数据格式
			const users = this.selectedUsers.map(userId => ({
				user_id: userId,
				tags: this.selectedTags
			}));
			
			setUserBindLabel({
				users: users
			}).then(res => {
				console.log('绑定标签结果:', res);
				if (res.code === 1) {
					this.$toast.success('标签绑定成功');
					
					// 触发事件，通知父组件绑定成功
					this.$emit('success', {
						userIds: this.selectedUsers,
						tagIds: this.selectedTags
					});
					
					this.$hide();
				} else {
					this.$toast.fail(res.msg || '标签绑定失败');
				}
			}).catch(err => {
				console.error('绑定标签失败:', err);
				this.$toast.fail('标签绑定失败，请重试');
			}).finally(() => {
				this.submitting = false;
			});
		}
	}
}
</script>

<style lang="less" scoped>
.customer-label {
	.label-container {
		display: flex;
		flex-direction: column;
		height: 100%;
		background: #fff;
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: var(--base-px-16);
		border-bottom: 1px solid #f0f0f0;
		
		.title {
			font-size: var(--base-px-16);
			font-weight: bold;
			color: #333;
		}
		
		.van-icon {
			font-size: var(--base-px-20);
			color: #666;
			cursor: pointer;
		}
	}

	.label-list {
		flex: 1;
		overflow-y: auto;
		padding: var(--base-px-12);
	}

	.label-item {
		padding: var(--base-px-12);
		margin-bottom: var(--base-px-8);
		background: #f7f8fa;
		border-radius: var(--base-px-8);
		
		&:last-child {
			margin-bottom: 0;
		}

		/deep/ .van-checkbox {
			width: 100%;
		}

		/deep/ .van-checkbox__label {
			flex: 1;
			margin-left: var(--base-px-8);
		}
	}

	.label-info {
		display: flex;
		align-items: center;
		gap: var(--base-px-12);
		
		.label-count {
			font-size: var(--base-px-12);
			color: #999;
		}
	}

	.footer {
		border-top: 1px solid #f0f0f0;
		padding: var(--base-px-12) var(--base-px-16);
		background: #fff;
	}

	.selected-info {
		font-size: var(--base-px-14);
		color: #666;
		margin-bottom: var(--base-px-12);
		text-align: center;
		
		.count {
			color: #1989fa;
			font-weight: bold;
			font-size: var(--base-px-16);
		}
		
		.user-name {
			color: #1989fa;
			font-weight: bold;
		}
	}

	.footer-buttons {
		display: flex;
		gap: var(--base-px-12);
		
		.van-button {
			flex: 1;
		}
	}
}
</style>
